// Check if an URL is local
export const isLocalUrl = (url: string) => {
  return !!url.match(/^(?:(?!http|www\.)).*/);
};

//Validate email
export const validateEmail = (email: string) => {
  if (!email || email === '') {
    return false;
  }
  const user = email.substring(0, email.indexOf('@'));
  const domain = email.substring(email.indexOf('@') + 1, email.length);
  if (
    user.length >= 1 &&
    domain.length >= 3 &&
    user.search('@') === -1 &&
    domain.search('@') === -1 &&
    user.search(' ') === -1 &&
    domain.search(' ') === -1 &&
    domain.search('.') !== -1 &&
    domain.indexOf('.') >= 1 &&
    domain.lastIndexOf('.') < domain.length - 1
  ) {
    return true;
  } else {
    return false;
  }
};

//Valid Brazilian area codes (DDDs)
const VALID_DDDS = [
  ...[11, 12, 13, 14, 15, 16, 17, 18, 19], // São Paulo
  ...[21, 22, 24], // Rio de Janeiro
  ...[27, 28], // Espírito Santo
  ...[31, 32, 33, 34, 35, 37, 38], // Minas Gerais
  ...[41, 42, 43, 44, 45, 46], // Paraná
  ...[47, 48, 49], // Santa Catarina
  ...[51, 53, 54, 55], // Rio Grande do Sul
  ...[61], // Distrito Federal e Goiás
  ...[62, 64], // Goiás
  ...[63], // Tocantins
  ...[65, 66], // Mato Grosso
  ...[67], // Mato Grosso do Sul
  ...[68], // Acre
  ...[69], // Rondônia
  ...[71, 73, 74, 75, 77], // Bahia
  ...[79], // Sergipe
  ...[81, 87], // Pernambuco
  ...[82], // Alagoas
  ...[83], // Paraíba
  ...[84], // Rio Grande do Norte
  ...[85, 88], // Ceará
  ...[86, 89], // Piauí
  ...[91, 93, 94], // Pará
  ...[92, 97], // Amazonas
  ...[95], // Roraima
  ...[96], // Amapá
  ...[98, 99], // Maranhão
];

//Validate phone
export const validatePhone = (phone: string, locale: 'pt' | 'en' = 'pt') => {
  if (phone === '' || phone === 'null') return false;
  const sanitizedPhone = phone.replace(/\D/g, '');

  if (locale === 'pt') {
    // Validação para telefones brasileiros
    if (sanitizedPhone.length < 10 || sanitizedPhone.length > 11) {
      return false;
    }

    // Verificar se tem DDD válido
    const ddd = parseInt(sanitizedPhone.substring(0, 2));
    if (!VALID_DDDS.includes(ddd)) {
      return false;
    }

    // Telefone fixo deve ter 10 dígitos, celular 11 dígitos
    // Celular deve começar com 9 após o DDD
    if (sanitizedPhone.length === 11) {
      const firstDigitAfterDDD = sanitizedPhone.charAt(2);
      if (firstDigitAfterDDD !== '9') {
        return false;
      }
    }

    return true;
  } else {
    // Validação mais flexível para telefones internacionais
    return sanitizedPhone.length >= 7 && sanitizedPhone.length <= 15;
  }
};

//Format phone with dynamic mask for Brazilian phones
export const formatPhoneBR = (text: string): string => {
  const digits = text.replace(/\D/g, '');

  if (digits.length <= 2) {
    return digits;
  }

  if (digits.length <= 6) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  }

  if (digits.length <= 10) {
    // Telefone fixo: (xx) xxxx-xxxx
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  }

  // Celular: (xx) xxxxx-xxxx
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7, 11)}`;
};

//Format phone (legacy function)
export const formatPhone = (text: string) => {
  let string = text;
  if (string.length < 16) {
    string = string.replace(/\D/g, '');
    string = string.replace(/^(\d{2})(\d)/g, '($1) $2');
    string = string.replace(/(\d)(\d{4})$/, '$1-$2');
  }
  return string.slice(0, 15);
};

// Transform new line to <br>
export const nl2br = (str?: string) => {
  if (typeof str === 'undefined' || str === null) return '';
  const breakTag = '<br>';
  return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
};

// Remove all string hashtags
export const removeHashtags = (str?: string) => {
  if (typeof str === 'undefined' || str === null) return '';
  return str.replace(/#/g, '');
};

// Generate a random hash for wizard submissions
export const generateSubmissionHash = (): string => {
  if (typeof window !== 'undefined') {
    // Client-side: use a simple random string
    return `${Date.now()}-${Math.random().toString(36).substring(2, 15)}`;
  } else {
    // Server-side: use crypto for better randomness
    const crypto = require('crypto');
    return crypto.randomBytes(16).toString('hex');
  }
};
